import { InjectionToken } from '@angular/core';

import { TourStep } from './tour.model';

export interface GuidedTourHandlers {
  /** The user reached the last step and finished. Not called on dismissal. */
  onComplete(): void;
  /** The tour ended, whether finished or dismissed. Always called, after `onComplete`. */
  onExit(): void;
}

/** The overlay engine. intro.js for now, `SuiGuide` once it exists — see #279. */
export interface GuidedTourEngine {
  start(steps: TourStep[], handlers: GuidedTourHandlers): void;
  stop(): void;
  isActive(): boolean;
}

export const GUIDED_TOUR_ENGINE = new InjectionToken<GuidedTourEngine>('GUIDED_TOUR_ENGINE');
